import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import Fondo from "./taxis.png";
import Swal from "sweetalert2";

import { BASE_URL } from "../../utils/index";
import {
  cerrarSwalTramitando,
  mostrarSwalTramitando,
} from "../../utils/funcionesSwal";

async function loginUser(credentials) {
  mostrarSwalTramitando();
  try {
    let response;
    try {
      response = await fetch(`${BASE_URL}/login`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(credentials),
      });
    } catch {
      throw new Error("No se pudo conectar con el servidor. Comprueba la conexión e inténtalo de nuevo.");
    }

    const data = await response.json().catch(() => null);
    if (!response.ok || !data) {
      throw new Error("No se pudo iniciar sesión. Comprueba tus datos e inténtalo de nuevo.");
    }
    return data;
  } finally {
    cerrarSwalTramitando();
  }
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Typography component="span" color="inherit">
        ASSOCIACIÓ PROVINCIAL D'AUTO TAXIS - LLEIDA
      </Typography>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    "@supports (min-height: 100dvh)": {
      minHeight: "100dvh",
    },
  },
  image: {
    backgroundImage: `url(${Fondo})`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.dark,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function Login({ sessionError = "" }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email === "" || password === "") {
      setLoginError("Introduce el correo y la contraseña.");
      return;
    }

    setLoginError("");
    setIsSubmitting(true);
    try {
      const response = await loginUser({ email, password });
      if (response.message === "Success!") {
        if (!response.idCliente || !response.perfil || !response.access_token) {
          throw new Error("El servidor devolvió una sesión incompleta. Contacta con soporte.");
        }
        localStorage.setItem("idCliente", response.idCliente);
        localStorage.setItem("email", email);
        localStorage.setItem("perfil", response.perfil);
        localStorage.removeItem("accessToken");
        sessionStorage.removeItem("accessToken");
        if (rememberMe) {
          localStorage.setItem("accessToken", response.access_token);
        } else {
          sessionStorage.setItem("accessToken", response.access_token);
        }
        localStorage.removeItem("password");
        localStorage.removeItem("csrfToken");
        window.location.reload();
      } else {
        setLoginError("Tus datos son incorrectos. Inténtalo de nuevo.");
      }
    } catch (error) {
      setLoginError(error.message || "No se pudo iniciar sesión. Inténtalo de nuevo.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const classes = useStyles();

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <AccountCircle />
          </Avatar>
          <Typography component="h1" variant="h5">
            Inicio de sesión de clientes
          </Typography>
          <form className={classes.form} noValidate onSubmit={handleSubmit}>
            {(sessionError || loginError) && (
              <Alert severity="error" role="alert">
                {loginError || sessionError}
              </Alert>
            )}
            <TextField
              variant="outlined"
              margin="normal"
              required
              type="email"
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={(event) => setRememberMe(event.target.checked)}
                  color="primary"
                />
              }
              label="Recuérdame"
            />
            <Button
              type="submit"
              disabled={isSubmitting}
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              {isSubmitting ? "Entrando…" : "Entrar"}
            </Button>
            <Grid container>
              <Grid item xs>
                <Link
                  component="button"
                  variant="body2"
                  onClick={() =>
                    Swal.fire("Contacta con la asociación para obtener tus datos de acceso.")
                  }
                >
                  ¿Olvidaste tu contraseña?
                </Link>
              </Grid>
            </Grid>
            <Box mt={8}>
              <Copyright />
            </Box>
          </form>
        </div>
      </Grid>
    </Grid>
  );
}
